import { translate } from "app/language/service"
import { IUser, IUserFormData, IUserFormDataErrors } from "user/model"

export function validateUserFormData(data: IUserFormData, allOtherUsers: IUser[]): IUserFormDataErrors {
  const errors: IUserFormDataErrors = {}
  if (!data.email) {
    errors.email = translate("label.field.required")
  } else if (!isEmailValid(data.email)) {
    errors.email = translate("label.field.invalid.value")
  } else if (allOtherUsers.find(u => u.email === data.email)) {
    errors.email = translate("user.email.already.exist", data.email)
  }
  if (!data.firstname) {
    errors.firstname = translate("label.field.required")
  }
  if (!data.lastname) {
    errors.lastname = translate("label.field.required")
  }
  return errors
}

const isEmailValid = (email: string): boolean => {
  const result = email.toLowerCase().match(
    // eslint-disable-next-line max-len
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  )
  return Array.isArray(result) && result.length > 0
}
